import * as React from 'react';

import { RCUtils } from './../../RCUtils';

var Config: any = require('../../Config.json');

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
    RefTemperatureUnit: server.RefTemperatureUnit[];
    BookedTemperatureUnit: any;
}

var self;
export class GridDropdownTempUnitRenderer extends React.Component<any, CustomEditRendererState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isEditMode: false,
            isDisabled: null,
            RefTemperatureUnit: this.props.colDef.cellRendererParams.refTempUnitData,
            BookedTemperatureUnit: props.value
        };
        self = this;
    }
  

    componentDidMount() {
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }

    cancelRowData(event: any) {

        this.props.onTempUnitChange(event.target.value);
        this.setState({ BookedTemperatureUnit: event.target.value });
        //setBookedTemperatureUnit(event.target.value);
    }

    componentWillReceiveProps(nextprops: any) {


    }
    BookedTemperatureUnitChange(e) {

        var Value: string = e.currentTarget.value;
        this.setState({
            BookedTemperatureUnit: Value
        });
        const tempUnits = this.state.RefTemperatureUnit.filter(obj => {
            return obj.TemperatureUnitCd == Value;
        });
        const row = this.props.data;
        row.bookedTemperatureQualifier = tempUnits[0].TemperatureUnitDesc;
        //this.gridOptions.api.applyTransaction({ update: [row] });
    }

    public render() {
        return <div>
            <select className='form-select' onChange={e => this.BookedTemperatureUnitChange(e)} value={this.state.BookedTemperatureUnit}>
                {
                    this.state.RefTemperatureUnit.map((unit, index) =>
                        <option key={unit.TemperatureUnitCd + index} value={unit.TemperatureUnitCd}>{unit.TemperatureUnitDesc}</option>
                    )}
            </select>
        </div>;
    }
}